module.exports = __webpack_public_path__ + "media/images/landing/illust/mockup-tel-c863c1f8526aec4acc44923781dbef89.png";